//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { programFileListApi, programrealNameApi, programFileDelApi } from '@/api/program';
import { uploader } from '@/utils/uploadCloud';
import { fileLinkDownLoad, formatBytes, getFileType, isTypeImage } from '@/libs/public';
export default {
  name: '',
  components: {
    imageViewer: function imageViewer() {
      return import('@/components/common/imageViewer');
    }
  },
  props: {
    programId: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      myHeaders: {
        authorization: 'Bearer ' + localStorage.getItem('token')
      },
      dialogFormVisible: false,
      percentShow: false,
      real_name: '',
      from: {
        name: '',
        time: ''
      },
      timeVal: [],
      where: {
        limit: 15,
        page: 1,
        program_id: this.programId
      },
      total: 0,
      fileData: [],
      srcList: [],
      rowData: {}
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function getList(val) {
      var _this = this;
      this.srcList = [];
      if (val == 1) {
        this.where.page = val;
      }
      programFileListApi(this.where).then(function (res) {
        _this.fileData = res.data.list;
        _this.total = res.data.count;
      });
    },
    timeChange: function timeChange(e) {
      this.where.time = e[0] + '-' + e[1];
      this.getList(1);
    },
    // 上传文件方法
    uploadServerLog: function uploadServerLog(params) {
      var _this2 = this;
      this.percentShow = true;
      var file = params.file;
      var options = {
        way: 2,
        relation_type: 'program',
        relation_id: this.programId,
        eid: 0
      };
      uploader(file, 0, 15, options).then(function (res) {
        // 获取上传文件渲染页面
        if (res.name) {
          _this2.getList();
          _this2.percentShow = false;
        }
      }).catch(function (err) {
        _this2.percentShow = false;
      });
    },
    pageChange: function pageChange(page) {
      this.where.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.where.limit = val;
      this.getList();
    },
    formatBytesFn: function formatBytesFn(size) {
      if (size) {
        return formatBytes(Number(size));
      } else {
        return '--';
      }
    },
    // 删除附件
    handleFileDelete: function handleFileDelete(row, index) {
      var _this3 = this;
      this.$modalSure('确定要删除此数据').then(function () {
        programFileDelApi(row.id).then(function (res) {
          _this3.fileData.splice(index, 1);
          if (_this3.where.page > 1 && _this3.fileData.length <= 0) {
            _this3.where.page--;
          }
          _this3.getList();
        });
      });
    },
    renameFn: function renameFn() {
      var _this4 = this;
      var data = {
        real_name: this.real_name
      };
      programrealNameApi(this.rowData.id, data).then(function (res) {
        _this4.getList();
        _this4.dialogFormVisible = false;
      });
    },
    // 重命名
    handleLabel: function handleLabel(row) {
      this.rowData = row;
      this.dialogFormVisible = true;
      this.real_name = row.real_name;
    },
    // 查看与下载附件
    lookViewer: function lookViewer(url) {
      var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (isTypeImage(url)) {
        this.srcList = [url];
        this.$refs.imageViewer.openImageViewer(url);
      } else {
        fileLinkDownLoad(url, name);
      }
    },
    toSrcIcon: function toSrcIcon(name) {
      return getFileType(name);
    },
    reset: function reset() {
      this.where.time = '';
      this.where.page = 1;
      this.where.limit = 10;
      this.where.name = '';
      this.timeVal = [];
      this.getList();
    }
  }
};